import React, { useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";
import { UserContext } from "../contexts/UserContext";
import Logo from "../assets/icons/logoEasy.svg";
import Deconection from "../assets/icons/iconDesconnected.svg";
import IconSimulation from '../components/icons/iconSimulation'
import IconClient from '../components/icons/iconClient'
import IconStatistique from '../components/icons/iconStatistique'
import IconSetting from "./icons/iconSetting";
import IconLive from "./icons/iconLive";
import IconBlog from "./icons/iconBlog";
import IconFinances from "./icons/iconFinances";
import IconCreateBlog from "./icons/iconCreateBlog";
import IconPushNotification from "./icons/iconPushNotification";

const Sidebar = ({notification}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, user , setRetardCall} = useContext(UserContext)
  const [isOpen, setIsOpen] = useState(false)

  const userRole = user?.user?.role; 

  const allMenuItems = [
    { label: "Live", path: "/admin-home", icon: IconSimulation, roles: ["admin"] },
    { label: "Live", path: "/agent-home", icon: IconSimulation, roles: ["agent"] , isNotification: notification },
    { label: "Home", path: "/marketing-home", icon: IconSimulation, roles: ["marketing"] },


    { label: "Live", path: "/super-admin-home", icon: IconSimulation, roles: ["super_admin"] },
    { label: "Live", path: "/super-agent-home", icon: IconSimulation, roles: ["super_agent"] },
    { label: "First Action", path: "/super-agent-live", icon: IconLive, roles: ["super_agent"],  isNotification: notification },


    { label: "Clients", path: "/agent-clients", icon: IconClient, roles: ["agent"] },
    { label: "Clients", path: "/clients", icon: IconClient, roles: ["admin", "super-admin", "super_agent"] },
    { label: "Statistiques", path: "/agent-statistic", icon: IconStatistique, roles: ["agent"] },
    { label: "Statistiques", path: "/super-agent-statistic", icon: IconStatistique, roles: [ "super_agent"] },
    { label: "Paramètres", path: "/settings", icon: IconSetting, roles: ["admin", "super_admin", "super_agent","agent"] },
    { label: "Create New Blog Post", path: "/super-agent-blog", icon: IconCreateBlog, roles: ["marketing"] },
    { label: "Articles List", path: "/super-agent-list-blogs", icon: IconBlog, roles: ["marketing"] },

    { label: "Gamification", path: "/gamification", icon: IconPushNotification, roles: ["marketing"] },
    
    { label: "Notification push", path: "/notification", icon: IconPushNotification, roles: ["marketing"] },

    { label: "Finance", path: "/super-agent-finances", icon: IconFinances, roles: ["super_agent"] },

    // { 
    //     label: "Transferts", 
    //     path: "/transfert", 
    //     icon: "💸", 
    //     roles: ["admin", "super-admin", "super_agent"] 
    // },
    // { 
    //     label: "Factures", 
    //     path: "/invoice", 
    //     icon: "📄", 
    //     roles: ["admin", "super_admin", "super_agent"] 
    // },
    // { 
    //     label: "Assurance", 
    //     path: "/insurance", 
    //     icon: "🛡️", 
    //     roles: ["admin", "super_admin", "super_agent"] 
    // },
  ];

  const menuItems = allMenuItems.filter(item => item.roles.includes(userRole));

  const handleLogout = () => {
    localStorage.removeItem("var");
    setUser(null);
    setRetardCall(null)
    navigate("/login");
  };

  const handleLogoRedirect = () => {
    const homePaths = {
        "admin": "/admin-home",
        "super-admin": "/super-admin-home",
        "super-agent": "/super-agent-home",
        "agent": "/agent-home",
        "marketing": '/marketing-home'
    };
    navigate(homePaths[userRole]);
  };

  return (
    <>
      {/* HEADER MOBILE */}
      <div className="lg:hidden bg-white  shadow-sm w-full p-4 flex justify-between items-center sticky top-0 z-50">
        <div className="flex items-center gap-2">
           <img  src={Logo} alt="Logo" className="w-24 h-8 rounded-full cursor-pointer" />
        </div>
        <button onClick={() => setIsOpen(!isOpen)} className="text-[#5d55e8] p-2 bg-blue-50 rounded-lg">
          {isOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* SIDEBAR */}
      <div className={classNames(
          "fixed inset-y-0 left-0 z-40 p-[24px] lg:m-[24px] w-[290px] bg-white lg:rounded-[16px]  border border-[#EEEEEE] transform transition-transform duration-300 ease-in-out flex flex-col justify-between ",
          isOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
        )}>
        <div>
          {/* <div className="hidden lg:flex p-6 flex-col items-center border-b border-gray-50"> */}
            <img 
              className=" hidden lg:flex cursor-pointer "
              src={Logo} 
              alt="Logo" 
              width={138}
              height={35}
              onClick={handleLogoRedirect}
            />
            {/* <span className="mt-3 font-black text-[#5d55e8] tracking-tighter uppercase text-xs">
              Espace {userRole.replace("-", " ")}
            </span> */}
          {/* </div> */}

          <nav className=" space-y-2 mt-20 lg:mt-[50px]">
            {menuItems.map((item) => {
             const Icon= item.icon
             return(
              <button className="flex items-center justify-between w-full "
                key={item.path}
                onClick={() => {
                  navigate(item.path);
                  setIsOpen(false);
                }}
                >
               <div className="group w-full flex items-center gap-3 py-3  transition-all">
                   <Icon fill={`${location.pathname === item.path ?  ' group-hover:stroke-[#4D36CC] stroke-[#5754E5]' : 'stroke-[#A5A5A5] group-hover:stroke-[#5754E5]'}`} />
                
                  <span className={classNames('font-medium text-[16px] ',
                    location.pathname === item.path
                      ? "text-[#5754E5] group-hover:text-[#4D36CC]"
                      : "text-[#A5A5A5] group-hover:text-[#5754E5]"
                    )}>
                    {item.label}
                  </span>
                  {item.isNotification && <div className="w-5 h-5 ml-2 text-[12px] flex items-center justify-center text-white bg-[#FF3B30] rounded-full"> {item.isNotification}</div>}
               </div>
               {location.pathname === item.path && <div className="h-[24px] bg-[#5754E5] w-[2px]"/>}
               
              </button>
            )})}
          </nav>
        </div>

        <div className="">
          <button onClick={handleLogout} className="w-full gap-3 flex items-center text-[#FF3B30] font-medium text-[16px] hover:text-[#]  group">
              <img src={Deconection} alt="Logout" width={25} height={25} />
              <span>Log Out</span>
          </button>
        </div>
      </div>

      {/* Overlay mobile */}
      {isOpen && <div className="fixed inset-0 bg-black/30 backdrop-blur-sm z-30 lg:hidden" onClick={() => setIsOpen(false)} />}
    </>
  );
};

export default Sidebar;